import { MailLink } from "./PrivacyPolicyUI";
import { privacyPolicysections } from "./privacyPolicyData";

export const PrivacyPolicySidebar = ({ activeId }) => (
  <aside className="w-[230px] shrink-0 max-[900px]:w-full sticky top-6 ">
    <div className="max-[900px]:static">
      <nav
        aria-label="Policy sections"
        className="rounded-xl border border-[#e4e8f5] bg-white px-4 pb-4 pt-[14px]"
      >
        <p className="mb-2.5 text-[13px] font-bold tracking-[-0.1px] text-[#1a2b6b]">
          On this page
        </p>

        <ol className="flex flex-col max-[900px]:flex-row max-[900px]:flex-wrap max-[900px]:gap-1.5">
          {privacyPolicysections.map((s) => {
            const active = s.id === activeId;
            return (
              <li key={s.id}>
                <a
                  href={`#${s.id}`}
                  aria-current={active ? "location" : undefined}
                  className={[
                    "block rounded-md border-l-2 py-[6px] pl-3 pr-2 text-[13.5px] leading-[1.35] no-underline transition-colors",
                    "max-[900px]:rounded-full max-[900px]:border max-[900px]:px-3 max-[900px]:py-1",
                    active
                      ? "border-[#0b1f5e] bg-[#f4f6fc] font-semibold text-[#0b1f5e] max-[900px]:border-[#0b1f5e]"
                      : "border-transparent text-[#4a578a] hover:bg-[#f9fafd] hover:text-[#0b1f5e] max-[900px]:border-[#e4e8f5]",
                  ].join(" ")}
                >
                  {s.title}
                </a>
              </li>
            );
          })}
        </ol>
      </nav>

      <div className="mt-3 rounded-xl border border-[#e4e8f5] bg-white px-4 py-[14px] text-[13px] leading-[1.5] text-[#4a578a] max-[900px]:hidden">
        <p className="mb-1.5 font-bold text-[#1a2b6b]">Questions?</p>
        <p className="mb-1">
          Privacy: <MailLink email="privacy@example.com" />
        </p>
        <p>
          Grievance Officer: <MailLink email="grievance@example.com" />
        </p>
        <p className="mt-2.5 text-[12px] text-[#6b7aab]">
          We reply within 30 days.
        </p>
      </div>
    </div>
  </aside>
);
